import * as Actions from '../actions/actions';
//@ts-ignore
import h from 'virtual-dom/h';
//@ts-ignore
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import { AlightStateType } from '../../../types/alight-state';
import { Store } from 'redux';
import { AdvocacyConfigData } from '../../../types/advocay-config-data';
//@ts-ignore
import { enableInputBox, disableInputBox } from '@alme/ui-web/modules/lib-inputbox-toggle/lib/lib-inputbox-toggle';
import {waitForIvaFunction} from '../../lib-alight-library/lib-alight-library';
import { validateCustomAvatarProperty,validateAvatarIsCustom,getCustomAvatar} from '../../custom-avatar/custom-avatar-helper';

export default class Renderer {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;
    _mutators: any;
    _childRenderers: any;
    initializationPromises: any;
    newAvatar: any;
    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>, initializationPromises: any, mutators = [], childRenderers = []) {
        this._store = store;
        this._mutators = mutators;
        this._childRenderers = childRenderers;
        this.initializationPromises = initializationPromises;
        waitForIvaFunction().then((result) =>{
        let productPayload;
        if (window.enableIVAasService){
            if (window.sessionStorage?.ivaServiceJsonData) {
                productPayload = JSON.parse(window.sessionStorage?.ivaServiceJsonData);
            }
            else {
                productPayload = window.enableIVAasService();
            }
        }
        else{
            if (window.enableIVA2Features){
                 productPayload = window.enableIVA2Features();
            }
        }
        if (validateCustomAvatarProperty(productPayload)) 
        {

            this.newAvatar = getCustomAvatar(productPayload);
        }
    });
    }

    getRender() {
        return () => {
            //  this prevents the launch button from appearing until product information has been received           
            //  only bail for missing legacy payload if IVAAS is not enabled
            const embededIva = document.getElementById(this._settings.Window.embeddedRootId);
            if(embededIva){
                return;
            }

            if (!window.enableIVAasService) {
                //  combined check for both product payload and complete initialization
                if (!window.enableIVA2Features) {
                    if (!this._store?.getState().Window.productPayload.payloadSaved)
                        console.warn("No IVA type discovered. Launchpoint not rendered");
                    return;
                }
            }

            return this.render();
        };
    }

    async waitForInitialization() {
        return await this.initializationPromises.onLoad;
    }

    render() {
        const dispatch = this._store?.dispatch;
        const needsFocusLocation = `${this._settings.stateLocations.Window.Input.Base}.${this._settings.stateLocations.Window.Input.NeedsFocus}`;
        const stateLocation = this._settings.stateLocations.Window.IsMinimized;

        const lastLaunchedLocation = this._settings.stateLocations.Window.urlLastLaunchedFrom;
        const advocacyVariablesBase = this._settings.stateLocations.Window.advocacyVariables.Base;

        const launchedProactively = this._settings.stateLocations.Window.advocacyVariables.launchedProactively;

        const IVAurl = this.getIvaUrl();

        let parameters = {
            className: this._settings.classNames.launchPoint,
            onclick: (e: any) => {
                if (dispatch != undefined) {
                    //check if proactive message on this page has already been given.
                    const messagesSentFlags = this._store?.getState().Window.advocacyVariables.messagesGiven;
                    const currentUrl = document.location.href;
                    for (const flag in messagesSentFlags) {
                        //  if this particular message was already given
                        //@ts-ignore
                        if (messagesSentFlags[flag]) {

                            //retrieve the chklstUrl that corresponds with this flag
                            const advocacyConfigData = this._store?.getState().Window.advocacyVariables.advocacyConfigData;

                            if (advocacyConfigData !== undefined && advocacyConfigData !== null) {
                                //@ts-ignore
                                const urlSubStringToFind = advocacyConfigData[flag];
                                //  if current url contains advocacy substring to search for
                                if (currentUrl.indexOf(urlSubStringToFind) > -1) {
                                    //only want to bail out if it was launched proactively not if the user clicked on it.
                                    const launchedProactivelyFlag = this._store?.getState().Window.advocacyVariables.launchedProactively;

                                    //  if Upoint initiated this
                                    if (launchedProactivelyFlag) {
                                        return;
                                    }
                                }
                            }
                        }
                    }   //  end loop that checks flags for all messages sent to bail if proactive
                    

                    if (window.GATrackingForIVA) {
                        window.GATrackingForIVA('External Link', 'Click', 'LinkId:' + 'IVA' + ' LinkDest:' + IVAurl);
                    }
                    else if (window.ga) {
                        window.ga('trackerUa1.send', 'event', 'External Link', 'click', 'LinkId:' + 'IVA' + ' LinkDest:' + IVAurl);
                        window.ga('trackerUa2.send', 'event', 'External Link', 'click', 'LinkId:' + 'IVA' + ' LinkDest:' + IVAurl);
                    }

                    //  set proactive launch flag back to false - we want this reset every time
                    this._store?.dispatch(Actions.setLaunchProctiveFlag(`${advocacyVariablesBase}.${launchedProactively}`, false));

                    dispatch(Actions.restoreAlmeWindow(stateLocation));

                    // const offersAvailable = this._store?.getState().Offers?.OffersAvailable ?? [];

                    // offersAvailable.forEach((offer) => {
                    //     this._store?.dispatch(Actions.markOfferProvided(offer));
                    // });

                    //  AON-2959 - need to disable focus on inputbox on initial launch for mobile
                    if (!this.isMobileMatched()) {
                        //@ts-ignore
                        dispatch(Actions.inputboxSetFocus(needsFocusLocation));
                    }

                    //  set urlLastLaunchedFrom so we can prevent proactive launching from page user just launched on
                    this._store?.dispatch(Actions.setLastUrlLaunchedFrom(`${lastLaunchedLocation}`, currentUrl));

                    // Disable the input box if the user is not in an active session
                    const inActiveSession = this._store?.getState()?.Conversation?.IsActiveSession ?? false;
                    if (inActiveSession) {
                        enableInputBox(this._store, this._settings, () => true);
                    }
                    else {
                        disableInputBox(this._store, this._settings, () => true);
                    }

                    return false;
                }
            },
            onmouseover: (e: any) => {
                return false;
            },

            onmouseout: (e: any) => {
                return false;
            },
        };

        this._mutators.forEach((mutate: any) => {
            parameters = mutate(parameters);
            }
        );

        const childNodes = [];

        const iconBackgroundClass = this._settings.classNames.launchPointIconBackground;
        const iconBackground = h("div", {className: iconBackgroundClass}, []);
        let elemt = document.getElementsByClassName(`${this._settings.classNames.launchPoint} ${this._settings.classNames.launchPointHype}`);
        if (elemt.length > 0 || parameters.className === `${this._settings.classNames.launchPoint} ${this._settings.classNames.launchPointHype}`) {
            iconBackground.properties.className = `${iconBackgroundClass} ${this._settings.classNames.launchPointIconBackgroundHype}`;

            const span = h('span', {
                className: this._settings.classNames.launchPointBadge,
                attributes: {
                    "auto-id": "badge-id",
                    },
                }, "1"
            );
            iconBackground.children.push(span);
        }
        else
        {
            const elements = document.getElementsByClassName(this._settings.classNames.launchPointBadge);
            while (elements.length > 0) {
                elements[0].remove();
            }
        }

        
        childNodes.push(iconBackground);

        if (validateAvatarIsCustom(this.newAvatar, this._settings)) {
            childNodes.push(h('div', {
                className: this._settings.classNames.launchPointIconAvatar,
                style: {
                    backgroundImage: this.newAvatar?`url("${this.newAvatar}")`:[],
                    backgroundSize: this.newAvatar?'70px': '50%',
                    backgroundRepeat: 'no-repeat',
                },
            }, []));
        }
        else
        {
            childNodes.push(h('div', {
                className: this._settings.classNames.launchPointIconAvatar,
                style: {
                    backgroundImage:[],
                    backgroundSize: '50%',
                    backgroundRepeat: 'no-repeat',
                },
            }, []));

        }
        
        // Commenting out Font Awesome Requirement due to issues on the Alight Pages
        // childNodes.push(h("icon", {className: this._settings.classNames.launchPointIcon}, [])); 
        childNodes.push(h("div", {className: this._settings.classNames.launchPointIconTemp}, []));

        const textNode = h('button type="button"', {
            className: this._settings.classNames.launchPointText,
            attributes: {
                "auto-id": "need-help",
                },
            }, this._settings.textConstants.launchPointText
        );

        childNodes.push(textNode);

        if (this.isMobileMatched()) {
            const missedMessages = this._store?.getState().LiveChat.MinimizedCount!;
            let missedMessagesStr = String(missedMessages);
            if (missedMessages > 0) {
                if (missedMessages > 3) {
                    missedMessagesStr = "3+";
                }
                const missedCount = h("p", {
                    className: this._settings.classNames.launchPointMissedNotifications,
                }, missedMessagesStr);

                childNodes.push(missedCount);
            }
        }

        this._childRenderers.forEach((render: any) => {
            childNodes.push(render());
        });
        return h('div', parameters, childNodes);
    }

    isMobileMatched() {
        const userAgent = navigator.userAgent || '';
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4)); //http://detectmobilebrowser.com
    }

    getProductInfoFromStore() {
        return this._store?.getState().Window.productPayload;
    }

    getIvaUrl() {



        // get script reference
        const scriptTags = document.getElementsByTagName('script');
        let url = '';
        for (let i = 0; i < scriptTags.length; i++) {
            const src = scriptTags[i].getAttribute('src');
            if (src && src > '' && src.toLowerCase().indexOf('nextit-script-manager.js') > -1) {
                url = src;
                break;
            }
        }

        return url;
    }

    shouldLaunchForAdvocacy() {

        let shouldLaunchIVA = false;

        let advocacyPages = {} as AdvocacyConfigData;

        if (this._store?.getState().Window.advocacyVariables.advocacyConfigData !== undefined) {
            advocacyPages = this._store.getState().Window.advocacyVariables.advocacyConfigData;
        }

        //  check the messagesGiven section here to determine whether we need to proactively message
        const whichMessagesWereGiven = this._store?.getState().Window.advocacyVariables.messagesGiven;
        const messageDelivered = false;

        const currentUrl = document.location.href;
        let containsEligiblePageList = false;
        if (currentUrl.indexOf(advocacyPages?.eligiblePageList) > -1) {
            containsEligiblePageList = true;
        }

        //@ts-ignore
        for (const messageFlag in whichMessagesWereGiven) {

            //  if we haven't given the proactive message for this flag yet
            //@ts-ignore
            if (!whichMessagesWereGiven[messageFlag] && !messageDelivered) {

                //let currentUrl = document.location.href;
                //@ts-ignore
                const advocacyUrl = advocacyPages[messageFlag];
                //check here to see if the URL contains the current messageFlag
                if (currentUrl.indexOf(advocacyUrl) > -1 && containsEligiblePageList) {
                    shouldLaunchIVA = true;
                }   //  end if URL contains in current messsageFlag

            }   //  end if proactive message not give yet.
        }   //  end for each messageFlag in whichMessagesWereGiven

        return shouldLaunchIVA;
    }   //  end shouldLaunchForAdvocacy
}


// WEBPACK FOOTER //
// ./modules/window-launch/renderers/renderer.ts